import React from "react";
import { Button, Column, Columns, Modal, Section, Title } from "@allxsmith/bestax-bulma";


export default function StatusChangeModal({
    onApprove,
    setOpen,
    open,
    new_status
}) {
    const onClick = () => {
        onApprove(new_status);
        setOpen(false);
    };

    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
            closeOnBlur
            active={open}
            onClose={() => {
                setOpen(false);
            }}
        >
            <Modal.Content>
                <Section style={{ backgroundColor: "white" }}>
                    <Title className="is-centered">
                        Make sure if any preparation needs to be done, the right job card has been raised.
                    </Title>
                    <Columns isMultiline>
                        <Column>
                            <Button color="info" onClick={onClick} isFullWidth>
                                Change Status
                            </Button>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );
}